import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Users/Simon/Documents/simonrose121.github.io/src/templates/projects-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <p>{`Reveal was a wordpress site built for a European research project in to using virtual reality for educational applications.`}</p>
    <p>{`The site was built using Wordpress and the`}
      {" "}
      {` `}
      <a href="https://avada.theme-fusion.com/" target="_blank">{`Avada`}</a>
      {" "}
      {` theme, with some custom CSS.`}</p>
    <p>{`Unfortunately, the site is no longer live.`}</p>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      